import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { AuthProvider } from "./auth/AuthProvider";
import { ThemeProvider } from "./theme/ThemeProvider";
import "./styles/index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            {/* Outer backstop: catches crashes in the app shell / auth
                pages that live outside Layout's per-page boundary. */}
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
            {/* Global toast layer. The axios response interceptor
                (client.ts) routes backend ``detail`` messages here so
                users see ``Storage quota exceeded: you've used 1.5/2 GB``
                instead of axios's generic "Request failed". The toast
                inherits the active theme via a class so light/dark
                surfaces stay consistent. */}
            <Toaster richColors position="top-right" closeButton
                     theme="system"
                     toastOptions={{ duration: 6000 }} />
          </QueryClientProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
